export default {"src":"/_next/static/media/AutenticRWA.4581ebbe.svg","height":36,"width":91,"blurWidth":0,"blurHeight":0};